"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Loading_1 = __importDefault(require("./Loading/Loading"));
var types_1 = require("../shared/async-result/types");
function ResultBoundary(_a) {
    var result = _a.result, children = _a.children, _b = _a.renderLoading, renderLoading = _b === void 0 ? function () { return react_1.default.createElement(Loading_1.default.Spinner, null); } : _b, _c = _a.renderError, renderError = _c === void 0 ? function (message) { return react_1.default.createElement("span", null, message); } : _c;
    if (result === undefined) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    switch (result.status) {
        case types_1.ResultStatus.LOADING:
            return renderLoading();
        case types_1.ResultStatus.ERROR:
            return renderError(result.message);
        case types_1.ResultStatus.LOADED:
            return children(result);
    }
}
exports.default = ResultBoundary;
